import { FileItem } from "../types/interfaces/filesStorage";

/** The last segment of a folder path: the name the folder has in storage. */
export const physicalFolderName = (fsource: string): string => {
  const parts = fsource.split("/").filter(Boolean);
  return parts.length ? parts[parts.length - 1] : "";
};

/**
 * Whether a rename would change nothing. A rename that moves the folder in
 * storage compares with the storage name too, so a label given earlier
 * without moving the folder can be saved again to move it.
 */
export const isUnchangedRename = (
  item: Pick<FileItem, "fname" | "fsource">,
  newName: string,
  movesStorage: boolean,
): boolean => {
  const name = newName.trim();
  if (!name) return true;
  if (name !== item.fname) return false;
  return !movesStorage || name === physicalFolderName(item.fsource);
};

/**
 * Breadcrumb mappings (label -> folder path) after a folder moved from
 * oldSource to newSource: its own label points at the new path, and so do the
 * labels of the folders inside it.
 */
export const remapFolderMappings = (
  mappings: Record<string, string>,
  oldSource: string,
  newSource: string,
  newName: string,
): Record<string, string> => {
  const remapped: Record<string, string> = {};
  for (const [label, source] of Object.entries(mappings)) {
    if (source === oldSource) continue;
    remapped[label] = source.startsWith(`${oldSource}/`)
      ? newSource + source.slice(oldSource.length)
      : source;
  }
  remapped[newName] = newSource;
  return remapped;
};
